export default __webpack_public_path__ + "static/media/loadingLogo.9ad86243.svg";